import { createLoader, parseAsInteger } from 'nuqs/server';

const keyMaps = {
  developerId: parseAsInteger,
};

const urlKeys = {
  developerId: 'developer',
};

const developerLoader = createLoader(keyMaps, { urlKeys });

export { developerLoader, keyMaps, urlKeys };
